module.exports = __webpack_public_path__ + "img/avatar.3a60b385.jpg";